import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import usePrevious from "@react-hook/previous";
import { DiscountForm } from "@temp/@next/components/organisms";
import { useCart, useCheckout } from "@temp/@sdk/react";
import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { TypedCartAddPromoCodeMutation } from "./queries";

function CartPromoCodeInner(_ref) {
  var cartAddPromoCode = _ref.cartAddPromoCode,
      loading = _ref.loading,
      setLoading = _ref.setLoading;
  var intl = useIntl();

  var _useCart = useCart(),
      items = _useCart.items,
      setCartPromoCode = _useCart.setCartPromoCode,
      cartPromoCode = _useCart.cartPromoCode,
      subtotalPrice = _useCart.subtotalPrice;

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      promoCodeDiscount = _useCheckout.promoCodeDiscount,
      addPromoCode = _useCheckout.addPromoCode,
      removePromoCode = _useCheckout.removePromoCode;

  var checkoutCreated = !!(checkout === null || checkout === void 0 ? void 0 : checkout.id);
  var addedVoucherCode = checkoutCreated ? promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode : cartPromoCode === null || cartPromoCode === void 0 ? void 0 : cartPromoCode.voucherCode;

  var _useState = useState(!!addedVoucherCode),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      promoCodeErrors = _useState4[0],
      setPromoCodeErrors = _useState4[1];

  var previousAddedVoucherCode = usePrevious(addedVoucherCode);
  useEffect(function () {
    if (!previousAddedVoucherCode && addedVoucherCode) {
      setActive(true);
    }
  }, [addedVoucherCode, previousAddedVoucherCode]);
  var addCheckoutPromoCode = useCallback(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(promoCode) {
      var _ref3, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return addPromoCode(promoCode);

            case 3:
              _ref3 = _context.sent;
              dataError = _ref3.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                setPromoCodeErrors(errors);
              } else {
                setPromoCodeErrors([]);
              }

              setLoading(false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [addPromoCode, setLoading]);
  var updateCartPromoCodeData = useCallback(
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(promoCode) {
      var result, _result$data$cartAddP, errors, discount, discountName, translatedDiscountName, voucherCode;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return cartAddPromoCode({
                variables: {
                  lines: items.map(function (line) {
                    return {
                      quantity: line.quantity,
                      variantId: line.variant.id
                    };
                  }),
                  promoCode: promoCode
                }
              });

            case 3:
              result = _context2.sent;

              if (result) {
                _result$data$cartAddP = result.data.cartAddPromoCode, errors = _result$data$cartAddP.errors, discount = _result$data$cartAddP.discount, discountName = _result$data$cartAddP.discountName, translatedDiscountName = _result$data$cartAddP.translatedDiscountName, voucherCode = _result$data$cartAddP.voucherCode;

                if (errors.length === 0) {
                  setCartPromoCode({
                    discount: discount,
                    discountName: discountName,
                    translatedDiscountName: translatedDiscountName,
                    voucherCode: voucherCode
                  });
                  setPromoCodeErrors([]);
                } else {
                  setPromoCodeErrors(errors);
                }
              }

              setLoading(false);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [cartAddPromoCode, items, setCartPromoCode, setLoading]);
  var prevSubTotalPriceAmount = usePrevious(subtotalPrice === null || subtotalPrice === void 0 ? void 0 : subtotalPrice.gross.amount);
  var subtotalChanged = prevSubTotalPriceAmount !== (subtotalPrice === null || subtotalPrice === void 0 ? void 0 : subtotalPrice.gross.amount);
  useEffect(function () {
    // update promo code on cart items change
    if (subtotalChanged && addedVoucherCode) {
      if (checkoutCreated) {
        addCheckoutPromoCode(addedVoucherCode);
      } else {
        updateCartPromoCodeData(addedVoucherCode);
      }
    }
  }, [addedVoucherCode, addCheckoutPromoCode, checkoutCreated, subtotalChanged, updateCartPromoCodeData]);
  var handleAddPromoCode = useCallback(function (_ref5) {
    var promoCode = _ref5.promoCode;

    if (checkoutCreated) {
      addCheckoutPromoCode(promoCode);
    } else {
      updateCartPromoCodeData(promoCode);
    }
  }, [addCheckoutPromoCode, checkoutCreated, updateCartPromoCodeData]);
  var handleRemovePromoCode = useCallback(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!checkoutCreated) {
              _context3.next = 7;
              break;
            }

            setLoading(true);
            _context3.next = 4;
            return removePromoCode(addedVoucherCode);

          case 4:
            setLoading(false);
            _context3.next = 8;
            break;

          case 7:
            setCartPromoCode(null);

          case 8:
            setActive(false);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [addedVoucherCode, checkoutCreated, removePromoCode, setCartPromoCode, setLoading]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "cart__footer__links"
  }, React.createElement("a", {
    href: "",
    className: "cart__footer__links-item"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "I have referral from my friend",
    "id": "components.OverlayManager.Cart.CartPromoCode.81331230"
  }, "id", "components.OverlayManager.Cart.CartPromoCode.81331230"))), !active && React.createElement("a", {
    href: "",
    className: "cart__footer__links-item",
    onClick: function onClick(e) {
      e.preventDefault();
      setActive(function (s) {
        return !s;
      });
    }
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "+ Add promo code",
    "id": "components.OverlayManager.Cart.CartPromoCode.2117765831"
  }, "id", "components.OverlayManager.Cart.CartPromoCode.2117765831")))), active && React.createElement(DiscountForm, {
    promoCodePending: loading,
    errors: promoCodeErrors,
    onClose: handleRemovePromoCode,
    discount: {
      promoCode: addedVoucherCode
    },
    handleSubmit: handleAddPromoCode
  }));
}

export function CartPromoCode(_ref7) {
  var setLoading = _ref7.setLoading,
      loading = _ref7.loading;
  return React.createElement(TypedCartAddPromoCodeMutation, null, function (cartAddPromoCode) {
    return React.createElement(CartPromoCodeInner, {
      setLoading: setLoading,
      loading: loading,
      cartAddPromoCode: cartAddPromoCode
    });
  });
}